import { config } from '../_config';
import { authHeader, handleResponse } from '../_helpers';

export const criadorSvr = {
  acListarMisCriadores
}

/* funcion que devuelve los criadores registrados de un usuario */
function acListarMisCriadores(dni) {
    const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...authHeader()
        },      
      };
      return fetch(`${config.apiUrl}/misCriadores`, requestOptions).then(handleResponse);
}